const unselectGrid = (self) => {
  const canvas_el = self._getCanvasElThrowable();
  const selector_grid_layer_el = self._getSelectorGridLayerElThrowable();
  if (self._selected_grid_id == null) {
    return;
  }
  const selected_grid_id = self._selected_grid_id;
  const selected_grid = self._grids.get(selected_grid_id);
  if (selected_grid == null) {
    throw new Error(`선택된 grid 를 찾을 수 업습니다. : ${selected_grid_id}`);
  }
  const { selector_grid_el } = selected_grid;
  if (selector_grid_layer_el.contains(selector_grid_el)) {
    selector_grid_layer_el.removeChild(selector_grid_el);
  }
  self._selected_grid_id = null;
  canvas_el.dispatchEvent(
    new CustomEvent("@mp/sticker-editor/unselect", {
      bubbles: true,
      cancelable: true,
      composed: false,
    })
  );
};
export const selectGrid = (self, id) => {
  const canvas_el = self._getCanvasElThrowable();
  const selector_grid_layer_el = self._getSelectorGridLayerElThrowable();
  if (id == null) {
    unselectGrid(self);
    return;
  }
  const grid = self._grids.get(id);
  if (grid == null) {
    throw new Error(`해당 id 의 grid 를 찾을 수 없습니다.`);
  }
  const { target_image_el, selector_grid_el } = grid;
  if (target_image_el == null) {
    throw new Error(`빈 grid 를 선택할 수 없습니다.`);
  }
  unselectGrid(self);
  selector_grid_layer_el.appendChild(selector_grid_el);
  self._selected_grid_id = id;
  canvas_el.dispatchEvent(
    new CustomEvent("@mp/sticker-editor/select", {
      bubbles: true,
      cancelable: true,
      composed: false,
      detail: {
        selected_grid_id: id,
      },
    })
  );
};
